import { JsonCallData, JsonCountdownData, JsonStartData, JsonWelcomeData, JsonWinnersData} from '@/components/game/_domain/server/json/prize/json-prize-data';

class DefaultStartData extends JsonStartData {
  constructor(id: number, prize: number, playercount: number, stripcount: number, now: number){
    super(id, prize, playercount, stripcount, now);
  }
}

class DefaultCallsData extends JsonCallData {
    constructor(callNumber: number, callCount: number){
       super(callNumber, callCount);
    }
}

class DefaultCountDownData extends JsonCountdownData {
  constructor(id: number, prize: number, playerCount: number, stripCount: number, startTime: number, purchasingOpenTime: number, purchasingCloseTime: number, chatOpenTime: number, chatCloseTime: number, secondsTilStart: number, now: number){
    super(id, prize, playerCount, stripCount, startTime, purchasingOpenTime, purchasingCloseTime, chatOpenTime, chatCloseTime, secondsTilStart, now);
  }
}

class DefaultWelcomeData extends JsonWelcomeData{
  constructor(id: number, prize: number, playerCount: number, startTime: number, secondsTilStart: number, calls: number[]){
   super(id, prize, playerCount, startTime, secondsTilStart, calls);
  }
}

class DefaultWinnersData extends JsonWinnersData {
  constructor(winners: string[], prizeEach: number, prizeTotal: number, now: number){
    super(winners, prizeEach, prizeTotal, now);
  }
}

export {
  DefaultCallsData,
  DefaultCountDownData,
  DefaultStartData,
  DefaultWelcomeData,
  DefaultWinnersData
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_json_defaults/_domain/models/prize.ts